import ExamResultRepository from "@/repositories/tuevs/ExamResultRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";
// import makeActions from "@/storages/Base/Actions";

export default {
    name: 'examresult',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne({commit, state}, id) {
            commit('setLoading', true)
            await ExamResultRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.examResult)
            })
            commit('setLoading', false)
        },
        async listAllPaginated({commit, state}, params) {
            commit('setLoading', true)
            await ExamResultRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.data)
                const paginator = {
                    page: params && params.page ? params.page : state.pagination.page,
                    per_page: params && params.per_page ? params.per_page : state.pagination.per_page,
                    total: response.data.data.total
                }
                commit('setPagination', paginator)
            })
            commit('setLoading', false)
        },
        async search({commit, state}, params) {
            commit('setLoading', true)
            await ExamResultRepository.fetchAll(params).then(response => {
                if (response.data.data.data.length > 0) {
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc, cur) => Object.assign(acc, {[cur.id]: cur}), {})))
                }
            })
            commit('setLoading', false)
        }
    }
}
